module.exports = __webpack_public_path__ + "static/media/no_results.bb16bebb.png";